import { FC } from 'react';

import { ThemeProvider } from '@mui/material';
import { useBreakpoints } from 'hooks';

import { STYLE_VARIANTS } from 'components/OnePageTemplates/interfaces/variants';
import { theme } from 'components/Theme/theme';

import { GanttChartMobile, GanttTable } from './components';
import { getGanttChardData } from './helpers';
import { IGanttChartProps as IProps } from './types';

export const GanttChart: FC<IProps> = ({ data, MobileCardWrapper, variant = STYLE_VARIANTS.CONTAINED }) => {
  const { doneChartData, inProgressChartData, toDoChartData, startDate, finishDate } = getGanttChardData(data);
  
  const { isMobile } = useBreakpoints();

  if (isMobile) {
    return (
      <ThemeProvider theme={theme}>
        <GanttChartMobile
          MobileCardWrapper={MobileCardWrapper}
          doneChartData={doneChartData}
          inProgressChartData={inProgressChartData}
          toDoChartData={toDoChartData}
        />
      </ThemeProvider>
    );
  }

  const desktopChartData = [...doneChartData, ...inProgressChartData, ...toDoChartData];

  return (
    <ThemeProvider theme={theme}>
      <GanttTable startDate={startDate} finishDate={finishDate} chartData={desktopChartData} variant={variant} />
    </ThemeProvider>
  );
};
